(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.boxi.pdf.view
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.page.lp-portal.report.pdf.view :refer [report]]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures :as
    pe-view-details-and-figures]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.esg :as pe-view-esg]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors :as
    pe-view-investors]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview :as
    pe-view-overview]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet :as
    pe-view-tearsheet]
   [frontend.ui.style.theme.core :as theme]))

(defn fee-summary-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Fee summary" :toc-item true}
   "Gp fees, carried interest and fund operating expenses, €"
   (->> report-data
        :summaries
        :fee-summary)
   {:skip-title-cell? true
    :odd-color        (theme/color [:pdf :table :odd-color])
    :even-color       (theme/color [:pdf :table :even-color])
    :heading-color    (theme/color [:pdf :table
                                    :heading-color])}))

(defn finance-summary-pages
  [report-data]
  (concat
   (table/dynamic-table-pages
    {:fund-name (:fund-name report-data) :page-title "Finance summary" :toc-item true}
    "Bridging finance and fund leverage facilities"
    (->> report-data
         :summaries
         :finance-summary)
    {:skip-headers? true
     :odd-color     (theme/color [:pdf :table :odd-color])
     :even-color    (theme/color [:pdf :table :even-color])
     :heading-color (theme/color [:pdf :table
                                  :heading-color])})
   (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Finance summary"}
                              "Bridging facility, €"
                              (->> report-data
                                   :summaries
                                   :finance-summary-2)
                              {:odd-color     (theme/color [:pdf :table :odd-color])
                               :even-color    (theme/color [:pdf :table :even-color])
                               :heading-color (theme/color [:pdf :table
                                                            :heading-color])})))

(defn boxi-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   (pe-view-esg/esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)
   (fee-summary-pages report-data)
   (finance-summary-pages report-data)))

(defn boxi
  [{:keys [fund-name reporting-period reference-date] :as report-data}]
  (report report-data (boxi-pages report-data) fund-name reporting-period reference-date))
